module.exports = __webpack_public_path__ + "static/media/multiverse8.ca136067.png";